/* eslint-disable complexity */
/* eslint-disable max-statements */
export const LOAD_CONFIG_REQUESTED = "WORKFLOW_WIDGET/LOAD_CONFIG_REQUESTED";
export const LOAD_CONFIG_SUCCESS = "WORKFLOW_WIDGET/LOAD_CONFIG_SUCCESS";
export const LOAD_CONFIG_FAIL = "WORKFLOW_WIDGET/LOAD_CONFIG_FAIL";

export const LOAD_CURRENT_INSTANCE_REQUESTED = "WORKFLOW_WIDGET/LOAD_CURRENT_INSTANCE_REQUESTED";
export const LOAD_CURRENT_INSTANCE_SUCCESS = "WORKFLOW_WIDGET/LOAD_CURRENT_INSTANCE_SUCCESS";
export const LOAD_CURRENT_INSTANCE_FAIL = "WORKFLOW_WIDGET/LOAD_CURRENT_INSTANCE_FAIL";

export const LOAD_CURRENT_ACTIONS_REQUESTED = "WORKFLOW_WIDGET/LOAD_CURRENT_ACTIONS_REQUESTED";
export const LOAD_CURRENT_ACTIONS_SUCCESS = "WORKFLOW_WIDGET/LOAD_CURRENT_ACTIONS_SUCCESS";
export const LOAD_CURRENT_ACTIONS_FAIL = "WORKFLOW_WIDGET/LOAD_CURRENT_ACTIONS_FAIL";

export const LOAD_DOCUMENT_GROUP_REQUESTED = "WORKFLOW_WIDGET/LOAD_DOCUMENT_GROUP_REQUESTED";
export const LOAD_DOCUMENT_GROUP_SUCCESS = "WORKFLOW_WIDGET/LOAD_DOCUMENT_GROUP_SUCCESS";
export const LOAD_DOCUMENT_GROUP_FAIL = "WORKFLOW_WIDGET/LOAD_DOCUMENT_GROUP_FAIL";

export const LOAD_PROJECT_GROUP_REQUESTED = "WORKFLOW_WIDGET/LOAD_PROJECT_GROUP_REQUESTED";
export const LOAD_PROJECT_GROUP_SUCCESS = "WORKFLOW_WIDGET/LOAD_PROJECT_GROUP_SUCCESS";
export const LOAD_PROJECT_GROUP_FAIL = "WORKFLOW_WIDGET/LOAD_PROJECT_GROUP_FAIL";

export const LOAD_ASSIGNABLE_USERS_REQUESTED = "WORKFLOW_WIDGET/LOAD_ASSIGNABLE_USERS_REQUESTED";
export const LOAD_ASSIGNABLE_USERS_SUCCESS = "WORKFLOW_WIDGET/LOAD_ASSIGNABLE_USERS_SUCCESS";
export const LOAD_ASSIGNABLE_USERS_FAIL = "WORKFLOW_WIDGET/LOAD_ASSIGNABLE_USERS_FAIL";

export const PROGRESS_WORKFLOW_STAGE_REQUESTED = "WORKFLOW_WIDGET/PROGRESS_WORKFLOW_STAGE_REQUESTED";
export const PROGRESS_WORKFLOW_STAGE_SUCCESS = "WORKFLOW_WIDGET/PROGRESS_WORKFLOW_STAGE_SUCCESS";
export const PROGRESS_WORKFLOW_STAGE_FAIL = "WORKFLOW_WIDGET/PROGRESS_WORKFLOW_STAGE_FAIL";

export const FORCE_WORKFLOW_STAGE_REQUESTED = "WORKFLOW_WIDGET/FORCE_WORKFLOW_STAGE_REQUESTED";
export const FORCE_WORKFLOW_STAGE_SUCCESS = "WORKFLOW_WIDGET/FORCE_WORKFLOW_STAGE_SUCCESS";
export const FORCE_WORKFLOW_STAGE_FAIL = "WORKFLOW_WIDGET/FORCE_WORKFLOW_STAGE_FAIL";

export const PROCESS_WORKFLOW_ACTION_REQUESTED = "WORKFLOW_WIDGET/PROCESS_WORKFLOW_ACTION_REQUESTED";
export const PROCESS_WORKFLOW_ACTION_SUCCESS = "WORKFLOW_WIDGET/PROCESS_WORKFLOW_ACTION_SUCCESS";
export const PROCESS_WORKFLOW_ACTION_FAIL = "WORKFLOW_WIDGET/PROCESS_WORKFLOW_ACTION_FAIL";

export const UPDATE_WORKFLOW_INSTANCE_REQUESTED = "WORKFLOW_WIDGET/UPDATE_WORKFLOW_INSTANCE_REQUESTED";
export const UPDATE_WORKFLOW_INSTANCE_SUCCESS = "WORKFLOW_WIDGET/UPDATE_WORKFLOW_INSTANCE_SUCCESS";
export const UPDATE_WORKFLOW_INSTANCE_FAIL = "WORKFLOW_WIDGET/UPDATE_WORKFLOW_INSTANCE_FAIL";

export const UPDATE_WORKFLOW_SETTINGS_REQUESTED = "WORKFLOW_WIDGET/UPDATE_WORKFLOW_SETTINGS_REQUESTED";
export const UPDATE_WORKFLOW_SETTINGS_SUCCESS = "WORKFLOW_WIDGET/UPDATE_WORKFLOW_SETTINGS_SUCCESS";
export const UPDATE_WORKFLOW_SETTINGS_FAIL = "WORKFLOW_WIDGET/UPDATE_WORKFLOW_SETTINGS_FAIL";

export const GET_COMPOUND_ROLE_REQUESTED = "WORKFLOW_WIDGET/GET_COMPOUND_ROLE_REQUESTED";
export const GET_COMPOUND_ROLE_SUCCESS = "WORKFLOW_WIDGET/GET_COMPOUND_ROLE_SUCCESS";
export const GET_COMPOUND_ROLE_FAIL = "WORKFLOW_WIDGET/GET_COMPOUND_ROLE_FAIL";

export const UPDATE_DOCUMENT_SETTINGS_REQUESTED = "WORKFLOW_WIDGET/UPDATE_DOCUMENT_SETTINGS_REQUESTED";
export const UPDATE_DOCUMENT_SETTINGS_SUCCESS = "WORKFLOW_WIDGET/UPDATE_DOCUMENT_SETTINGS_SUCCESS";
export const UPDATE_DOCUMENT_SETTINGS_FAIL = "WORKFLOW_WIDGET/UPDATE_DOCUMENT_SETTINGS_FAIL";


export const GO_TO_V2_DOCUMENT_REQUESTED = "WORKFLOW_WIDGET/GO_TO_V2_DOCUMENT_REQUESTED";

// eslint-disable-next-line no-unused-vars
export default (state = {
    docGroup: {},
    docGroupRole: {},
    errors: [],
    hasInitialDataActions: false,
    hasInitialDataConfig: false,
    hasInitialDataDocs: false,
    hasInitialDataInstance: false,
    instance: {},
    loading: 0,
    myActions: [],
    projectGroups: [],
    projectUsers: [],
    updating: 0,
    v2Docs: [],
    widgetConfig: {}
}, { type, data }) => {
    switch (type) {
    case LOAD_CONFIG_REQUESTED: {
        ++state.loading;
        return state;
    }
    case LOAD_CONFIG_SUCCESS: {
        --state.loading;
        state.hasInitialDataConfig = true;
        state.widgetConfig = data;
        return state;
    }
    case LOAD_CONFIG_FAIL: {
        --state.loading;
        state.errors.push({ error: data, type });
        return state;
    }
    case LOAD_CURRENT_INSTANCE_REQUESTED: {
        ++state.loading;
        return state;
    }
    case LOAD_CURRENT_INSTANCE_SUCCESS: {
        --state.loading;
        const { allv2Documents, instance } = data;
        state.hasInitialDataInstance = true;
        state.v2Docs = allv2Documents || state.v2Docs;
        state.instance = instance || state.instance;
        return state;
    }
    case LOAD_CURRENT_INSTANCE_FAIL: {
        --state.loading;
        state.errors.push({ error: data, type });
        return state;
    }
    case LOAD_CURRENT_ACTIONS_REQUESTED: {
        ++state.loading;
        return state;
    }
    case LOAD_CURRENT_ACTIONS_SUCCESS: {
        --state.loading;
        state.hasInitialDataActions = true;
        state.myActions = data;
        return state;
    }
    case LOAD_CURRENT_ACTIONS_FAIL: {
        --state.loading;
        state.errors.push({ error: data, type });
        return state;
    }
    case LOAD_DOCUMENT_GROUP_REQUESTED: {
        ++state.loading;
        return state;
    }
    case LOAD_DOCUMENT_GROUP_SUCCESS: {
        --state.loading;
        const { users, groups, docGroup } = data;
        state.hasInitialDataDocs = true;
        state.docGroup = docGroup;
        // state.projectUsers = users;
        // state.projectGroups = groups;
        return state;
    }
    case LOAD_DOCUMENT_GROUP_FAIL: {
        --state.loading;
        state.errors.push({ error: data, type });
        return state;
    }
    case LOAD_PROJECT_GROUP_REQUESTED: {
        ++state.loading;
        return state;
    }
    case LOAD_PROJECT_GROUP_SUCCESS: {
        --state.loading;
        state.projectGroups = data;
        return state;
    }
    case LOAD_PROJECT_GROUP_FAIL: {
        --state.loading;
        state.errors.push({ error: data, type });
        return state;
    }
    case LOAD_ASSIGNABLE_USERS_REQUESTED: {
        ++state.loading;
        return state;
    }
    case LOAD_ASSIGNABLE_USERS_SUCCESS: {
        --state.loading;
        state.projectUsers = data;
        return state;
    }
    case LOAD_ASSIGNABLE_USERS_FAIL: {
        --state.loading;
        state.errors.push({ error: data, type });
        return state;
    }
    case PROGRESS_WORKFLOW_STAGE_REQUESTED: {
        ++state.loading;
        return state;
    }
    case PROGRESS_WORKFLOW_STAGE_SUCCESS: {
        --state.loading;
        state.instance = { ...data, v2Document: state.instance.v2Document };
        return state;
    }
    case PROGRESS_WORKFLOW_STAGE_FAIL: {
        --state.loading;
        state.errors.push({ error: data, type });
        return state;
    }
    case FORCE_WORKFLOW_STAGE_REQUESTED: {
        ++state.loading;
        return state;
    }
    case FORCE_WORKFLOW_STAGE_SUCCESS: {
        --state.loading;
        state.instance = { ...data, v2Document: state.instance.v2Document };
        return state;
    }
    case FORCE_WORKFLOW_STAGE_FAIL: {
        --state.loading;
        state.errors.push({ error: data, type });
        return state;
    }
    case PROCESS_WORKFLOW_ACTION_REQUESTED: {
        ++state.loading;
        return state;
    }
    case PROCESS_WORKFLOW_ACTION_SUCCESS: {
        --state.loading;
        const index = state.myActions.findIndex(({ _id }) => _id === data._id);
        if (index > -1){
            state.myActions[index] = data;
        }
        return state;
    }
    case PROCESS_WORKFLOW_ACTION_FAIL: {
        --state.loading;
        state.errors.push({ error: data, type });
        return state;
    }
    case UPDATE_WORKFLOW_INSTANCE_REQUESTED: {
        ++state.loading;
        return state;
    }
    case UPDATE_WORKFLOW_INSTANCE_SUCCESS: {
        --state.loading;
        state.instance = { ...data, v2Document: state.instance.v2Document };
        return state;
    }
    case UPDATE_WORKFLOW_INSTANCE_FAIL: {
        --state.loading;
        state.errors.push({ error: data, type });
        return state;
    }
    case UPDATE_WORKFLOW_SETTINGS_REQUESTED: {
        ++state.loading;
        return state;
    }
    case UPDATE_WORKFLOW_SETTINGS_SUCCESS: {
        --state.loading;
        const {
            instance, docGroup, updateGroupIds, removeGroupIds, role 
        } = data;
        state.instance = { ...instance, v2Document: state.instance.v2Document };
        state.docGroup = docGroup;
        if (role){
            state.projectGroups.forEach(group => {
                if (updateGroupIds.includes(group.id)) {
                    group.roles.push(role);
                } else if (removeGroupIds.includes(group.id)) {
                    group.roles = group.roles.filter(({ role: r }) => r.name === role.name);
                }
            });
        }
        return state;
    }
    case UPDATE_WORKFLOW_SETTINGS_FAIL: {
        --state.loading;
        state.errors.push({ error: data, type });
        return state;
    }
    case UPDATE_DOCUMENT_SETTINGS_REQUESTED: {
        ++state.loading;
        return state;
    }
    case UPDATE_DOCUMENT_SETTINGS_SUCCESS: {
        --state.loading;
        const {
            instance, docGroup, updateGroupIds, removeGroupIds, role 
        } = data;
        state.instance = { ...instance, v2Document: state.instance.v2Document };
        state.docGroup = docGroup;
        if (role){
            state.projectGroups.forEach(group => {
                if (updateGroupIds.includes(group.id)) {
                    group.roles.push(role);
                } else if (removeGroupIds.includes(group.id)) {
                    group.roles = group.roles.filter(({ role: r }) => r.name === role.name);
                }
            });
        }
        return state;
    }
    case UPDATE_DOCUMENT_SETTINGS_FAIL: {
        --state.loading;
        state.errors.push({ error: data, type });
        return state;
    }
    case GET_COMPOUND_ROLE_REQUESTED: {
        ++state.loading;
        return state;
    }
    case GET_COMPOUND_ROLE_SUCCESS: {
        --state.loading;
        state.docGroupRole = data;
        return state;
    }
    case GET_COMPOUND_ROLE_FAIL: {
        --state.loading;
        state.errors.push({ error: data, type });
        return state;
    }
    default: return state;
    }
};

export const requestLoadWorkflowWidgetConfig = data => ({ type: LOAD_CONFIG_REQUESTED, data });
export const successLoadWorkflowWidgetConfig = data => ({ type: LOAD_CONFIG_SUCCESS, data });
export const failLoadWorkflowWidgetConfig = data => ({ type: LOAD_CONFIG_FAIL, data });

export const requestLoadCurrentWorkflowInstance = data => ({ type: LOAD_CURRENT_INSTANCE_REQUESTED, data });
export const successLoadCurrentWorkflowInstance = data => ({ type: LOAD_CURRENT_INSTANCE_SUCCESS, data });
export const failLoadCurrentWorkflowInstance = data => ({ type: LOAD_CURRENT_INSTANCE_FAIL, data });

export const requestLoadCurrentUserActions = data => ({ type: LOAD_CURRENT_ACTIONS_REQUESTED, data });
export const successLoadCurrentUserActions  = data => ({ type: LOAD_CURRENT_ACTIONS_SUCCESS, data });
export const failLoadCurrentUserActions  = data => ({ type: LOAD_CURRENT_ACTIONS_FAIL, data });

export const requestLoadDocumentGroup = data => ({ type: LOAD_DOCUMENT_GROUP_REQUESTED, data });
export const successLoadDocumentGroup  = data => ({ type: LOAD_DOCUMENT_GROUP_SUCCESS, data });
export const failLoadDocumentGroup  = data => ({ type: LOAD_DOCUMENT_GROUP_FAIL, data });

export const requestLoadProjectGroup = data => ({ type: LOAD_PROJECT_GROUP_REQUESTED, data });
export const successLoadProjectGroup = data => ({ type: LOAD_PROJECT_GROUP_SUCCESS, data });
export const failLoadProjectGroup  = data => ({ type: LOAD_PROJECT_GROUP_FAIL, data });

export const requestLoadAssignableUsers = data => ({ type: LOAD_ASSIGNABLE_USERS_REQUESTED, data });
export const successLoadAssignableUsers = data => ({ type: LOAD_ASSIGNABLE_USERS_SUCCESS, data });
export const failLoadAssignableUsers  = data => ({ type: LOAD_ASSIGNABLE_USERS_FAIL, data });

export const requestProgressWorkflowStage = (data, resolve, reject) => ({ type: PROGRESS_WORKFLOW_STAGE_REQUESTED, data, resolve, reject });
export const successProgressWorkflowStage  = data => ({ type: PROGRESS_WORKFLOW_STAGE_SUCCESS, data });
export const failProgressWorkflowStage  = data => ({ type: PROGRESS_WORKFLOW_STAGE_FAIL, data });

export const requestForceWorkflowToStage = (data, resolve, reject) => ({ type: FORCE_WORKFLOW_STAGE_REQUESTED, data, resolve, reject });
export const successForceWorkflowToStage  = data => ({ type: FORCE_WORKFLOW_STAGE_SUCCESS, data });
export const failForceWorkflowToStage  = data => ({ type: FORCE_WORKFLOW_STAGE_FAIL, data });

export const requestProcessAction = (data, resolve, reject) => ({ type: PROCESS_WORKFLOW_ACTION_REQUESTED, data, resolve, reject });
export const successProcessAction  = data => ({ type: PROCESS_WORKFLOW_ACTION_SUCCESS, data });
export const failProcessAction  = data => ({ type: PROCESS_WORKFLOW_ACTION_FAIL, data });

export const requestUpdateWorkflowInstance = (data, resolve, reject) => ({ type: UPDATE_WORKFLOW_INSTANCE_REQUESTED, data, resolve, reject });
export const successUpdateWorkflowInstance  = data => ({ type: UPDATE_WORKFLOW_INSTANCE_SUCCESS, data });
export const failUpdateWorkflowInstance  = data => ({ type: UPDATE_WORKFLOW_INSTANCE_FAIL, data });

export const requestUpdateWorkflowSettings = (data, resolve, reject) => ({ type: UPDATE_WORKFLOW_SETTINGS_REQUESTED, data, resolve, reject });
export const successUpdateWorkflowSettings  = data => ({ type: UPDATE_WORKFLOW_SETTINGS_SUCCESS, data });
export const failUpdateWorkflowSettings  = data => ({ type: UPDATE_WORKFLOW_SETTINGS_FAIL, data });

export const requestUpdateDocumentSettings = (data, resolve, reject) => ({ type: UPDATE_DOCUMENT_SETTINGS_REQUESTED, data, resolve, reject });
export const successUpdateDocumentSettings  = data => ({ type: UPDATE_DOCUMENT_SETTINGS_SUCCESS, data });
export const failUpdateDocumentSettings  = data => ({ type: UPDATE_DOCUMENT_SETTINGS_FAIL, data });

export const requestGetOrCreateCompoundRole = (data, resolve, reject) => ({ type: GET_COMPOUND_ROLE_REQUESTED, data, resolve, reject });
export const successGetOrCreateCompoundRole  = data => ({ type: GET_COMPOUND_ROLE_SUCCESS, data });
export const failGetOrCreateCompoundRole  = data => ({ type: GET_COMPOUND_ROLE_FAIL, data });

export const requestGoToV2DocumentById = (data, resolve, reject) => ({ type: GO_TO_V2_DOCUMENT_REQUESTED, data, resolve, reject });
